import { render, staticRenderFns } from "./topMessageBar.vue?vue&type=template&id=478a118a&scoped=true"
import script from "./topMessageBar.vue?vue&type=script&lang=js"
export * from "./topMessageBar.vue?vue&type=script&lang=js"
import style0 from "./topMessageBar.vue?vue&type=style&index=0&id=478a118a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a118a",
  null
  
)

export default component.exports